window.fastspring2Error = function(errorCode, errorMessage) {
	$('<div class="flashes"><div class="flash flash-system flash-error">The payment gateway seems to be offline. It usually doesn\'t take long to get fixed. Please try again in about 5 minutes.</div></div>').prependTo($('.all'));
	alert('Message from the payment gateway: ' + errorMessage);
}

function fastspring2Data(data) {
	// I don't know, if we need this, probably not
}

function fastspring2PopupEvent(data) {
}

window.fastspring2PopupClosed = function(data) {
	if (data != null) {
		window.location.href = "/checkout/done/?txn_id=" + data.reference;
	} else {
		window.location.reload();
	}
}


window.fastspring2WebhookReceived = function(data) {
	if (!data) return;
	const { reference, tags, tax, subtotal, currency } = data;
	if (!tags || !tags.dataLayerData) return;
	let dlData = tags.dataLayerData;
	dlData.ecommerce.currencyCode = currency;
	dlData.ecommerce.purchase.actionField.id = reference;
	dlData.ecommerce.purchase.actionField.revenue = subtotal;
	dlData.ecommerce.purchase.actionField.tax = tax;
	dataLayer.push(dlData);
}
